import React, { useEffect, useRef, useState } from 'react';
import * as _ from 'lodash';
import * as cn from 'classnames';
import './App.css';
import './data.js';
import { Login } from './components/views/login.js';
import { AppFrame } from './components/main/app-frame.js';
import { FilterProvider } from './contexts/filter-context.js';
import { ModalProvider } from './contexts/modal-context.js';
import { OrganizationProvider } from './contexts/organization-context.js';
import { NavigationProvider } from './contexts/navigation-context.js';
import { HoverProvider } from './contexts/hover-context.js';

const App = () => {
  const [isLoginSuccess, setLoginSuccess] = useState(window.localStorage.getItem('saltExchangeLoginSuccess') === 'true');

  const handleLoginSuccess = () => {
    window.localStorage.setItem('saltExchangeLoginSuccess', 'true');
    setLoginSuccess(true);
  };

  return (
    <div style={{ position: 'absolute', inset: 0, lineHeight: 'normal' }}>
      <div className="parent-container">
        {!isLoginSuccess && <Login onLoginSuccess={handleLoginSuccess} />}
        {isLoginSuccess && (
          <ModalProvider>
            <NavigationProvider>
              <OrganizationProvider>
                <FilterProvider>
                  <HoverProvider>
                    <AppFrame />
                  </HoverProvider>
                </FilterProvider>
              </OrganizationProvider>
            </NavigationProvider>
          </ModalProvider>
        )}
      </div>
    </div>
  );
};

export default App;
